import { FC, ReactNode } from 'react'
import { Collapse } from 'antd'
import PerIcon from '../Icon'
import PerText from '../Text'
import PerSpacer from '../Spacer'
import './index.less'

const { Panel } = Collapse

type PanelProps = {
  heading?: string
  headingElement?: ReactNode
  content: ReactNode
}

type PerCollapseProps = {
  panels: PanelProps[]
  name?: string
  defaultActiveKey?: number
  stripMargin?: boolean
  className?: string
  iconSize?: number
  onChange?: () => void
}

export const PerCollapse: FC<PerCollapseProps> = ({
  panels,
  name,
  defaultActiveKey = -1,
  stripMargin = false,
  className = '',
  iconSize = 10,
  onChange,
}) => {
  const renderKey = (key: number, name?: string) => `collapse-${name && `${name}-`}${key}`
  return (
    <Collapse
      onChange={onChange}
      bordered={false}
      defaultActiveKey={renderKey(defaultActiveKey, name)}
      expandIcon={() => <PerIcon name={'chevronRight_stroke'} size={iconSize} color="secondary" />}
    >
      {panels.map((panel, index: number) => (
        <Panel
          className={className}
          header={
            !!panel.headingElement ? (
              panel.headingElement
            ) : (
              <PerText appearance="subheading" mb="none">
                {panel.heading || ''}
              </PerText>
            )
          }
          key={renderKey(index, name)}
        >
          {!!stripMargin ? panel.content : <PerSpacer my="s">{panel.content}</PerSpacer>}
        </Panel>
      ))}
    </Collapse>
  )
}
